export const purchaseParticipantStatus = [{
  value: 'Undefined', label: 'Undefined', color: 'grey'
}, {
  value: 'Pending', label: 'Pending', color: 'yellows'
}, {
  value: 'Rejected', label: 'Rejected', color: 'red'
}, {
  value: 'Accepted', label: 'Accepted', color: 'green'
}, {
  value: 'Cancelled', label: 'Cancelled', color: 'red'
}];